import React from "react"
import { nanoid } from "nanoid"

function Steps({ steps }) {
    const handleClick = (e) => e.target.previousElementSibling.firstChild.checked = !e.target.previousElementSibling.firstChild.checked

    return (
        <> 
            <h3>Steps</h3>
            {
                steps.map( content => {
                    return  <section key={nanoid()} className="steps">
                        {
                            content.step.split("\n")
                                .filter(el => el !== "")
                                .map( item => {
                                    return  <div key={nanoid()}>
                                        <div>
                                            <input type="checkbox" name="ingredient" aria-label="ingredient" />
                                        </div>
                                        <label htmlFor="ingredient" onClick={handleClick}>{item}</label>
                                    </div>
                                })
                        }
                    </section>
                })
            } 
        </>
    )
}

export default Steps
